const styles = theme => ({
  wrap: {
    minHeight: 200,
    // backgroundImage: "url('contact.jpg')",
    marginTop: 30,
    marginBottom: 50,
    backgroundAttachment: "fixed",
    backgroundPosition: "center",
    backgroundSize: "cover",
    position: "relative",

    "&:before": {
      content: "attr(href)",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, .8)"
    }
  },
  container: {
    minHeight: 200,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    color: "white",

    "& a": {
      padding: "15px 30px",
      borderRadius: 5,
      fontSize: 16,
      display: "flex",
      alignItems: "center",
      backgroundColor: theme.colors.primary,
      fontWeight: "600",

      "& svg": {
        marginRight: 10
      },

      "&:hover": {
        transform: "translateY(-5px)",
        boxShadow: "3px 3px 20px rgba(42, 193, 127, .5)"
      }
    }
  }
});

export default styles;
